import { render, staticRenderFns } from "./Lifekey.vue?vue&type=template&id=79893924&scoped=true&"
import script from "./Lifekey.vue?vue&type=script&lang=js&"
export * from "./Lifekey.vue?vue&type=script&lang=js&"
import style0 from "./Lifekey.vue?vue&type=style&index=0&id=79893924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79893924",
  null
  
)

export default component.exports